import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { ChallengeButton, AfterImageCard, CalendarLoader } from '../../../../common';
import { CHALLENGE_30_IMAGES, EVENT_NAME_BDK_CHALLENGE_2026 } from '../../../../common/challengeConstants';
import './ChallengeMyWeightout.scss';
import { getChallenge30DaysImagesAction, postChallenge30DaysImagesSubmitAction } from '../../../../actions/challenge/challengeImageUploadActions';
import { getDataFromSession } from '../../../../utill.func';
import { fetchChallengeTeamDetail } from '../../../../actions';
import LoadingOverlay from 'react-loading-overlay';

export default function ChallengeMyWeightout() {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const customer = useSelector(state => state.customer);
  const imageCardSectionRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { teamData } = useSelector((state) => state.challengeTeamDashboard);
  const { imagesData } = useSelector((state) => state.challengeImageUpload);
  const params = queryString.parse(location.search);
  const aboId = params["aboId"];
  const partyId = params['partyId'] || '';
  const eventId = params['eventId'] || '';
  const challengeId = params['challengeId'] || teamData?.eventId;

  const selectedImages =
  JSON.parse(localStorage.getItem(CHALLENGE_30_IMAGES) || '{}');

  const allImagesSelected =
    Boolean(
      selectedImages.after_center &&
      selectedImages.after_left &&
      selectedImages.after_right
    );
    
  useEffect(() => {
    const filterUserData = teamData?.users?.find(
      (user) => user?.partyId === partyId,
    );
    filterUserData && setUserData(filterUserData);
  }, [teamData]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getChallengeTeamDashboardData();

        await dispatch(
          getChallenge30DaysImagesAction({
            eventType: EVENT_NAME_BDK_CHALLENGE_2026,
            eventId,
            challengeId,
          })
        );
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getChallengeTeamDashboardData = async () => {
      try {
        await dispatch(
          fetchChallengeTeamDetail({
            amwayNumber: params['aboId'] || customer?.amwayNumber,
            partyId: params['partyId'] || customer?.partyId,
            challengeId: process.env.CHALLENGE_EVENT_ID_30_CHALLENGE || '30a478e7-5445-48a4-b717-94542b82a358',
          }),
        );
      } catch (error) {
        throw error;
      }
    };


  const handleSubmit = () => {
    setIsLoading(true);
    const imagesObj = JSON.parse(localStorage.getItem(CHALLENGE_30_IMAGES));
    dispatch(
      postChallenge30DaysImagesSubmitAction({
        eventType: EVENT_NAME_BDK_CHALLENGE_2026,
        eventId,
        challengeId,
        metaData: {
          image1: extractUploadedImagesURLtoSubmit(imagesObj.after_center),
          image2: extractUploadedImagesURLtoSubmit(imagesObj.after_left),
          image3: extractUploadedImagesURLtoSubmit(imagesObj.after_right),
        },
      })).then(() => {
        return dispatch(
          getChallenge30DaysImagesAction({
            eventType: EVENT_NAME_BDK_CHALLENGE_2026,
            eventId,
            challengeId,
          })
        );
      }).finally(() => {
        setIsLoading(false);
        localStorage.removeItem(CHALLENGE_30_IMAGES);
      });
  };

  const extractUploadedImagesURLtoSubmit = (imagePath) => `/${imagePath.split('/').slice(3).join('/')}`;

  const imagesUploaded =  Boolean(imagesData?._id);
  const isValidDurationForUpload = teamData?.challengeDay >= 31 && teamData?.challengeDay <= 37;

  if (loading) {
    return (
      <LoadingOverlay
        active={true}
        spinner
        text="Loading..."
      >
        <div style={{ height: "100vh" }} />
      </LoadingOverlay>
    );
  }

  return <div className="challenge-weightout-container">
        <div className="challenge-weightout-title">อัปโหลดรูป</div>
    <div
      className={`challenge-weightout-heading ${
        !isValidDurationForUpload ? 'challenge-weightout-heading__disabled' : ''
      }`}
    >
      +30 Days
      <span className="challenge-weightout-heading-span">
        Check-in
      </span>
    </div>
    <div className="challenge-weightout-hintTitle">อัปโหลดภาพถ่ายหลังจบการแข่งขัน</div>
    <div className="challenge-weightout-hintDescription">เพื่อประกอบการพิจารณารางวัลชนะเลิศ</div>
    <div className="challenge-weightout-hintDescription">หากไม่มีภาพถ่ายท่านจะถูกตัดสิทธิ์จากการพิจารณา</div>
    <div className={`challenge-weightout-banner${!imagesUploaded && !isValidDurationForUpload ? ' challenge-weightout-banner__not-allowed' : ''}`}>
      {!imagesUploaded && !isValidDurationForUpload ? <>
          <div className="challenge-weightout-banner-text">ไม่สามารถอัปโหลดรูปภาพได้</div>
          <div className="challenge-weightout-banner-text">เนื่องจากเลยกำหนดเวลาแล้ว</div>
        </> : <>
        <div className="challenge-weightout-banner-text">ตัวอย่างภาพ อัปโหลดภาพหลังจบการแข่งขัน</div>
        <div className="challenge-weightout-banner-text">ระบบเปิดตั้งแต่วันที่ 31-37 ของการแข่งขัน</div>
        <div className="challenge-weightout-banner-text">*หมายเหตุ*</div>
        <div className="challenge-weightout-banner-text">กรุณาสวมเครื่องแต่งกายและรองเท้าในการถ่ายภาพ</div> </> 
      }
    </div>
    <div
      className={`challenge-weightout-image-upload-caution ${
        !isValidDurationForUpload
          ? 'challenge-weightout-image-upload-caution__disabled'
          : ''
      }`}
    >
      *รูปต้องมีขนาดมากกว่า 1 MB
    </div>
    <div className="my-image-upload-card" ref={imageCardSectionRef}>
      <AfterImageCard
        eventId={challengeId}
        redirectionEventIdQuery={eventId}
        partyId={partyId}
        userId={userData?.challengeUserId}
        aboId={userData?.aboId}
        isValidDurationForUpload={isValidDurationForUpload}
        imagesUploaded={imagesUploaded} />
    </div>
    <div className="challenge-weightout-footer">
      <ChallengeButton 
        btnTitle={imagesUploaded ? 'ส่งรูปภาพสำเร็จ' : 'ส่งรูปภาพ'} 
        successBtn={!imagesUploaded && isValidDurationForUpload && allImagesSelected} 
        onBtnClick={handleSubmit} 
        disabled={imagesUploaded || !isValidDurationForUpload || !allImagesSelected} 
        disabledBtn={imagesUploaded || !isValidDurationForUpload || !allImagesSelected} />
    </div>
    <CalendarLoader showLoading={isLoading} />
  </div>;
}
